import orange from 'material-ui/colors/orange'
import pink from 'material-ui/colors/pink'
import teal from 'material-ui/colors/teal'
import grey from 'material-ui/colors/grey'
import blue from 'material-ui/colors/blue'
// import { fade } from 'material-ui/styles/colorManipulator'
import spacing from 'material-ui/styles/spacing'
import zIndex from 'material-ui/styles/zIndex'

export default {
  spacing,
  zIndex: zIndex,
  fontFamily: 'Roboto, sans-serif',
  palette: {
    primary: orange,
    primary1Color: orange[800],
    primary2Color: grey[400],
    primary3Color: orange[100],
    accent1Color: pink['A200'],
    accent2Color: teal['A100']
  }
}


// WEBPACK FOOTER //
// ./src/theme.js